<span class="LV_validation_message LV_invalid" translate>{{ controlErrors }}</span>